export default __webpack_public_path__ + "static/media/mid3.4945c851.jpg";